import ShortCutKey from '../../interaction/shortcutkey/index';
import CopySystem from '../../interaction/copySystem';

function init(): void {
    // 复制
    ShortCutKey.on({
        keyName: 'ctrl+c',
        callback: (event) => {
            CopySystem.copy();
        }
    });
    ShortCutKey.on({
        keyName: 'command+c',
        callback: (event) => {
            CopySystem.copy();
        }
    });

    // 剪切
    ShortCutKey.on({
        keyName: 'ctrl+x',
        callback: (event) => {
            CopySystem.cut();
        }
    });
    ShortCutKey.on({
        keyName: 'command+x',
        callback: (event) => {
            CopySystem.cut();
        }
    });

    // 粘贴
    ShortCutKey.on({
        keyName: 'ctrl+v',
        callback: (event) => {
            CopySystem.paste();
        }
    });
    ShortCutKey.on({
        keyName: 'command+v',
        callback: (event) => {
            CopySystem.paste();
        }
    });
}

export default {
    init
};
